import { Result } from "domain/entities/result";
import { DiseaseRepository } from "domain/repositories";

export default class DeleteUseCase {
    private diseaseRepository: DiseaseRepository;
    
    public constructor(diseaseRepository: DiseaseRepository) {
        this.diseaseRepository = diseaseRepository
    }

    public async deleteDisease(id: number, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.diseaseRepository.deleteDisease(id, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}